<div role="main" class="dom-container apex-kit-fds-theme">
  <div id="dom-overlay"></div>
  <div id="dom-widget"></div>
  <div id="dom-sronly" aria-live="assertive"></div>
</div>
